import { createApiRequest } from "../common";
import { GetOrgPictureRequestContent, GetOrgPictureResponseContent } from '@equaliq/api-model-v2';

export const getOrgPictureApi = async (request: GetOrgPictureRequestContent): Promise<GetOrgPictureResponseContent> => {
  const apiRequest = createApiRequest<GetOrgPictureResponseContent>('post', '/orgs/getOrgPicture');
  return apiRequest(request);
};
